import React from 'react';
export function Breakthrough() {
  return <section className="mb-16" data-id="element-19">
      <h2 className="text-[28px] sm:text-[32px] md:text-[36px] font-semibold text-[#1B2951] mb-6 leading-tight font-['Playfair_Display']" data-id="element-20">
        The Breakthrough That Changed Everything
      </h2>
      <p className="text-lg text-gray-700 mb-4" data-id="element-21">
        I became obsessed with finding a solution. Why did collagen take 90
        days? Was it just accepted science, or were we missing something?
      </p>
      <p className="text-lg text-gray-700 mb-6" data-id="element-22">
        Then, at a nutraceutical conference in Paris, I met Dr. Valérie Bizot
        from SEPPIC France. She introduced me to something that made my jaw
        drop:
      </p>
      <div className="mb-6 bg-white p-4 rounded-lg shadow-sm flex items-center justify-center" data-id="element-23">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tZEHutnWNwY9dYj7PPyYdb/Screenshot_2025-08-06_at_5.54.54_PM.png" alt="SEPPIC - Science That Cares" className="h-16 md:h-20" data-id="element-24" />
      </div>
      <div className="mb-8" data-id="element-25">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iFeVz5G9iUvhEr6rP69Tvy/u8357357769_Professional_photograph_of_Indian_businessman_Nih_9b8883d7-10c9-4891-aea2-620d3190d63e_3.png" alt="Nihaal Mariwala speaking at the International Nutraceutical Summit in Paris" className="w-full rounded-lg shadow-md mb-6" data-id="element-26" />
      </div>
      {/* The Breakthrough Discovery Box */}
      <div className="bg-gradient-to-br from-[#FFB88C] to-[#FFE5D9] border border-[#FFB88C]/50 rounded-lg p-6 mb-8 relative" data-id="element-27">
        {/* New full-width breakthrough banner */}
        <div className="absolute top-0 right-0 left-0 bg-[#FF8E72] text-white py-1.5 text-center font-bold text-sm z-10 rounded-t-lg" data-id="element-28">
          BREAKTHROUGH
        </div>
        {/* Add padding at the top to make room for the banner */}
        <div className="pt-8" data-id="element-29">
          <div className="flex flex-col md:flex-row gap-6 items-center mb-6" data-id="element-30">
            <div className="md:w-1/3 bg-white p-3 rounded-lg shadow-md flex items-center justify-center" data-id="element-31">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sju9aNYQu4CmkwmCxQupHn/u8357357769_Professional_product_photography_of_CERAMOSIDES_w_2ffe6834-741d-42ac-9542-8b3d3ee34795_1.png" alt="CERAMOSIDES wheat-based phytoceramide powder with wheat stalks" className="w-full rounded-lg" data-id="element-32" />
            </div>
            <div className="md:w-2/3" data-id="element-33">
              <h3 className="text-2xl font-bold text-[#1B2951] mb-3 flex items-center" data-id="element-34">
                CERAMOSIDES™
                <span className="ml-2 text-sm bg-white px-2 py-1 rounded-full text-[#FF8E72]" data-id="element-35">
                  Novel Discovery
                </span>
              </h3>
              <p className="text-[#1B2951] mb-4" data-id="element-36">
                Dr. Bizot and her team at SEPPIC France had discovered a unique
                wheat extract called Ceramosides that performed incredibly
                effectively at protecting the skin barrier from within.
              </p>
              <div className="flex flex-wrap gap-3" data-id="element-37">
                <span className="bg-white/70 px-3 py-1 rounded-full text-sm font-medium text-[#1B2951]" data-id="element-38">
                  Clinically Proven
                </span>
                <span className="bg-white/70 px-3 py-1 rounded-full text-sm font-medium text-[#1B2951]" data-id="element-39">
                  15-Day Results
                </span>
                <span className="bg-white/70 px-3 py-1 rounded-full text-sm font-medium text-[#1B2951]" data-id="element-40">
                  Patented Formula
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* What I Learned Box */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8" data-id="element-41">
        <h4 className="font-semibold text-blue-900 mb-4" data-id="element-42">What I Learned:</h4>
        <div className="mb-6" data-id="element-43">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/k36ztQqnvhbGBAtpov7amg/Screenshot_2025-08-06_at_1.11.56_PM.png" alt="Comparison of normal ceramide level skin with intact barrier versus decreased ceramide level skin with damaged barrier" className="w-full rounded-lg shadow-md mb-4" data-id="element-44" />
          <p className="text-sm text-gray-600 text-center italic" data-id="element-45">
            The science behind why ceramides are critical for skin health
          </p>
        </div>
        <p className="text-blue-800 mb-4" data-id="element-46">
          Dr. Bizot told me that Ceramides form a key part of your skin's
          protective barrier - and that low ceramide levels directly correlate
          with moisture loss and pollutant entry into the skin barrier. What's
          more - ceramide levels decrease by up to 30% after age 30. This
          shocked me - Trisha has recently crossed the dreaded 3-0. I had a
          brain wave - PERHAPS, just PERHAPS, ceramides might help improve
          collagen's performance?
        </p>
      </div>
    </section>;
}